{
  "analysis.saved.tab": "Kayıtlı analizler",
  "analysis.saved.author.title": "Analiz oluştur",
  "analysis.saved.author.description": "Kayıtlı Yaşam metriklerini sınırlı bir boyut ve zaman aralığıyla birleştir.",
  "analysis.saved.author.noMetrics": "Henüz kayıtlı metrik yok",
  "analysis.saved.author.noMetricsDescription": "Yeniden kullanılabilir analiz oluşturmadan önce Yaşam'da bir metrik oluştur.",
  "analysis.saved.author.name": "Analiz adı",
  "analysis.saved.author.measures": "Ölçümler",
  "analysis.saved.author.measuresHint": "Aynı Yaşam şemasından en fazla dört metrik seç.",
  "analysis.saved.author.dimension": "Boyut",
  "analysis.saved.author.window": "Zaman aralığı",
  "analysis.saved.author.comparison": "Önceki zaman aralığıyla karşılaştır",
  "analysis.saved.author.comparisonUnavailable": "Karşılaştırmalar, zaman serisi boyutu olmayan sınırlı toplamlar için kullanılabilir.",
  "analysis.saved.author.save": "Analizi kaydet",
  "analysis.saved.author.saveError": "Analiz kaydedilemedi. Güncel Yaşam alanlarını ve metriklerini kontrol et.",
  "analysis.saved.dimension.none": "Boyut yok",
  "analysis.saved.dimension.day": "Zaman · gün",
  "analysis.saved.dimension.week": "Zaman · hafta",
  "analysis.saved.dimension.month": "Zaman · ay",
  "analysis.saved.window.all": "Tüm zamanlar",
  "analysis.saved.window.day": "Bugün",
  "analysis.saved.window.week": "Bu hafta",
  "analysis.saved.window.month": "Bu ay",
  "analysis.saved.window.rolling": "Son 7 gün",
  "analysis.saved.browse.title": "Kayıtlı analizler",
  "analysis.saved.browse.description": "Yeniden kullanılabilir bir tanımı güncel Yaşam kayıtlarında çalıştır.",
  "analysis.saved.browse.measureCount": "{{count}} ölçüm",
  "analysis.saved.browse.measureCount_plural": "{{count}} ölçüm",
  "analysis.saved.browse.run": "Çalıştır",
  "analysis.saved.browse.empty": "Kayıtlı analiz yok",
  "analysis.saved.browse.emptyDescription": "En az bir ölçüm seç ve ilk tanımını kaydet.",
  "analysis.saved.results.title": "Sonuçlar",
  "analysis.saved.results.description": "{{count}} sınırlı sonuç satırı.",
  "analysis.saved.results.measure": "Ölçüm",
  "analysis.saved.results.previous": "önceki {{value}}",
  "analysis.saved.results.empty": "Eşleşen sonuç yok",
  "analysis.saved.missing": "Kullanılamıyor"
}
